// extracted by mini-css-extract-plugin
export var block = "styles-module--block--1WjK_";
export var block_txt = "styles-module--block_txt--1aPXR";
export var block_txt_title = "styles-module--block_txt_title--3o8G7";
export var block_txt_desc = "styles-module--block_txt_desc--3rByK";
export var block_txt_btn = "styles-module--block_txt_btn--1FpYt";
export var block_img = "styles-module--block_img--PR0GV";
export var block_img_elem = "styles-module--block_img_elem--1gHGf";